/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessFormAppMemoQuery$parameters.ts';
import type { JiraBusinessFormAppMemoQuery } from './__generated__/JiraBusinessFormAppMemoQuery.graphql.ts';

type FormEntrypointComponent = EntryPointComponent<
	{
		formQuery: JiraBusinessFormAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const formEntrypoint: EntryPoint<FormEntrypointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<FormEntrypointComponent>(
			/* webpackChunkName: "async-business-form-entrypoint" */ './JiraBusinessFormAppMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					formQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
				},
			};
		},
	});
